import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, Circle, DrawingManager, InfoWindow, Polygon } from '@react-google-maps/api';


const MapStudentLocation = (props) => {
    const { studentsWithCoordinates, schoolCoordinates, userDrawings, setUserDrawings, isLoaded, loadError } = props;

    // State to track the currently clicked marker or circle
    const [clickedStudent, setClickedStudent] = useState(null);
    const [isDrawing, setIsDrawing] = useState(false);


    const handleDrawingComplete = (drawing, mode) => {
        // console.log("Drawing completed:", mode, ", drawing: ", drawing);

        // Ask the user for a drawing name
        const drawingName = prompt("Enter a name for this drawing:");

        if (!drawingName) {
            console.warn("Drawing name is required. Drawing not saved.");
            return; // Exit if no name is provided
        }

        const newDrawing = {
            drawingId: userDrawings.length + 1,
            drawingName: drawingName, // Use the name provided by the user
            drawingType: mode,
        };

        switch (mode) {
            case "circle":
                newDrawing.center = drawing.getCenter().toJSON();
                newDrawing.radius = drawing.getRadius();
                break;

            case "polygon":
                newDrawing.polygonPath = drawing.getPath().getArray().map((latLng) => latLng.toJSON());
                break;

            default:
                console.warn("Unknown drawing mode:", mode);
                return;
        }

        setUserDrawings((prev) => [...prev, newDrawing]);
        // console.log("Drawing saved:", newDrawing);

        // Optionally keep the drawing on the map or remove it
        // drawing.setMap(null);
    };


    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
            {isLoaded && !loadError ? (
                <GoogleMap
                    center={schoolCoordinates}
                    zoom={13}
                    mapContainerStyle={{ width: "100%", height: "80vh" }}
                    options={{
                        zoomControl: true,
                        draggable: !isDrawing,
                        zoomControlOptions: {
                            position: window.google.maps.ControlPosition.RIGHT_CENTER,
                        },
                        mapTypeControl: true,
                    }}
                >
                    {/* School Marker */}
                    <Marker position={schoolCoordinates} label="School" />

                    {/* Additional Pointers */}
                    {studentsWithCoordinates.map((student) => (
                        <React.Fragment key={student.studentId}>
                            {student.coordinate && (
                                <Marker
                                    position={student.coordinate}
                                    icon={{
                                        url: "https://sms.cooledsys.com//school_kid.png",
                                        scaledSize: new window.google.maps.Size(30, 30),
                                    }}
                                    onClick={() => setClickedStudent(student)}
                                />
                            )}
                            {clickedStudent?.studentId === student.studentId && (
                                <InfoWindow
                                    position={student.coordinate}
                                    onCloseClick={() => setClickedStudent(null)}
                                >
                                    <div style={{ fontSize: "12px", maxWidth: "100px", padding: "1px" }}>
                                        <strong>{student.student}</strong>
                                        <br />
                                        ID: {student.studentId}
                                    </div>
                                </InfoWindow>
                            )}
                        </React.Fragment>
                    ))}



                    {/* Render Saved Drawings */}
                    {userDrawings.length > 0 &&
                        userDrawings.map((drawing, index) => {
                            if (drawing.drawingType === "circle") {
                                return (
                                    <Circle
                                        key={`circle-${index}`}
                                        center={drawing.center}
                                        radius={drawing.radius}
                                        options={{
                                            fillColor: "#FF0000",
                                            fillOpacity: 0.3,
                                            strokeWeight: 2,
                                            clickable: false,
                                            editable: false,
                                            zIndex: 1,
                                        }}
                                    />
                                );
                            } else if (drawing.drawingType === "polygon") {
                                return (
                                    <Polygon
                                        key={`polygon-${index}`}
                                        paths={drawing.polygonPath}
                                        options={{
                                            fillColor: "#00FF00",
                                            fillOpacity: 0.5,
                                            strokeWeight: 2,
                                            clickable: false,
                                            editable: false,
                                            zIndex: 1,
                                        }}
                                    />
                                );
                            }
                            return null; // For unsupported drawing types
                        })}



                    {/* Drawing Manager */}
                    <DrawingManager
                        options={{
                            drawingControl: true,
                            drawingControlOptions: {
                                position: window.google.maps.ControlPosition.TOP_CENTER,
                                drawingModes: ["circle", "polygon"],
                            },
                            polygonOptions: {
                                fillColor: "#00FF00",
                                fillOpacity: 0.5,
                                strokeWeight: 2,
                                clickable: true,
                                editable: true,
                                zIndex: 1,
                            },
                            circleOptions: {
                                fillColor: "#FF0000",
                                fillOpacity: 0.3,
                                strokeWeight: 2,
                                clickable: true,
                                editable: true,
                                zIndex: 1,
                            },
                        }}
                        onCircleComplete={(circle) => handleDrawingComplete(circle, "circle")}
                        onPolygonComplete={(polygon) => handleDrawingComplete(polygon, "polygon")}
                        onDrawingModeChanged={(mode) => {
                            // console.log("Drawing mode changed:", mode);
                            setIsDrawing(!!mode);
                        }}
                    />
                </GoogleMap>
            ) : loadError ? (
                <h2>Error Loading Map</h2>
            ) : (
                <h2>Loading...</h2>
            )}
        </div>
    );
};

export default MapStudentLocation;
